export const STATUS_THRESHOLDS = {
  ON_TRACK: 80,
  WATCH: 60,
} as const;

export enum PacingStatus {
  OnTrack = "OnTrack", // >= 80% of budget
  Watch = "Watch", // 60-79% of budget
  NeedsAction = "NeedsAction", // < 60% of budget
  NoData = "NoData",
}

export interface PacingMonthData {
  month: number;
  year: number;
  monthName: string;
  isPastMonth: boolean;

  budgetRooms: number | null;
  budgetRevenue: number | null;
  budgetOccupancy: number | null;

  currentRooms: number;
  currentRevenue: number;
  currentOccupancy: number;

  priorRooms: number;
  priorRevenue: number;
  priorOccupancy: number;

  stlyRooms: number;
  stlyRevenue: number;
  stlyOccupancy: number;
  stlyRate: number | null;

  // Rate/ADR fields
  budgetRate: number | null;
  currentRate: number | null;
  priorRate: number | null;

  percentToGoalRooms: number | null;
  percentToGoalRevenue: number | null;

  // Variance vs prior period (pickup)
  varianceRooms: number;
  varianceRevenue: number;
  varianceRate: number | null;

  varianceVsSTLY: number;
  varianceVsSTLYPercent: number | null;

  // Reach to Goal calculations
  reachToGoalRooms: number | null;
  reachToGoalRevenue: number | null;
  reachToGoalRate: number | null;

  roomsStatus: PacingStatus;
  revenueStatus: PacingStatus;
}

export type ComparisonPeriod = "1_day" | "3_days" | "7_days" | "14_days" | "30_days";

export const PACING_COMPARISON_OPTIONS = [
  { label: "1 day", value: "1_day" },
  { label: "3 days", value: "3_days" },
  { label: "7 days", value: "7_days" },
  { label: "14 days", value: "14_days" },
  { label: "30 days", value: "30_days" },
];

export interface RevenueSummaryMonth {
  month: number;
  year?: number;

  // Current OTB (future months)
  onBooksRevenue: number;
  onBooksOccupancy: number;
  onBooksBookings?: number;
  onBooksAdr?: number;

  // Actual (past months)
  actualRevenue: number;
  actualOccupancy: number;
  actualBookings?: number;
  actualAdr?: number;

  // STLY
  revenuePrevYear?: number;
  occupancyPrevYear?: number;
  bookingsPrevYear?: number;

  // Budget (embedded in response)
  budget?: {
    soldRooms?: number;
    roomsRevenue?: number;
    adr?: number;
    occupancy?: number;
    availableRooms?: number;
  };
}

export interface PickUpReportItem {
  date: string;
  sum: number;
  bookings?: number;
  priorSum?: number;
  stlyPickUp?: number;
}

export interface AnnualBudgetMonth {
  month: number;
  availableRooms?: number;
  soldRooms?: number;
  occupancy?: number;
  adr?: number;
  revpar?: number;
  roomsRevenue?: number;
}

export interface PacingTotals {
  budgetRooms: number;
  budgetRevenue: number;
  budgetRate: number | null;
  currentRooms: number;
  currentRevenue: number;
  currentRate: number | null;
  priorRooms: number;
  priorRevenue: number;
  priorRate: number | null;
  varianceRooms: number;
  varianceRevenue: number;
  varianceRate: number | null;
  reachToGoalRooms: number | null;
  reachToGoalRevenue: number | null;
  reachToGoalRate: number | null;
  percentToGoal: number | null;
  stlyRooms: number;
  stlyRevenue: number;
  stlyRate: number | null;
}

export type GoalViewMode = "budget" | "stly";
